<div>
  <span class="text-slice" [innerHTML]="expand || !isOverflow ? text : (text | slice:0:size) + '...'"></span>
  <span class="text-slice-show-more cursor-pointer"
        [class.text-pink]="isPink"
        [class.text-primary]="isPrimary"
        [class.text-blue-2]="isAddMoreBlue"
        *ngIf="!expand && isOverflow"
        (click)="expand=true">&nbsp;
    <span *ngIf="!moreLabel">{{'common.textSlice.readMore' | translate}}</span>
    <span *ngIf="moreLabel">{{moreLabel}}</span>
  </span>

  <span class="text-slice-show-more cursor-pointer"
        *ngIf="expand && isOverflow"
        [class.text-pink]="isPink"
        [class.text-primary]="isPrimary"
        [class.text-blue-2]="isAddMoreBlue"
        (click)="expand=false">&nbsp;
    <span *ngIf="!hideLabel">{{'common.textSlice.hide' | translate}}</span>
    <span *ngIf="hideLabel">{{hideLabel}}</span>
  </span>
</div>
